<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- <b-card-text>Device.</b-card-text> -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <b-card title="Master Device">
          <b-row>
            <!-- Type -->
            <b-col cols="12">
              <b-form-group
                label="Type"
                label-for="v-Type"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Type"
                  rules="required"
                >
                  <v-select
                    id="v-Type"
                    v-model="form.select_1"
                    placeholder="Chose Type"
                    autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="TypeOptions"
                    :reduce="TypeOptions => TypeOptions.value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group
                label="Name"
                label-for="v-Name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    id="v-Name"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Kode -->
            <b-col cols="12">
              <b-form-group
                label="Kode"
                label-for="v-Kode"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kode"
                  rules="required"
                >
                  <b-form-input
                    id="v-Kode"
                    v-model="form.text_2"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Kode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="12">
              <b-form-group
                label="Note"
                label-for="v-Note"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Note"
                  rules="required"
                >
                  <b-form-textarea
                    id="v-Note"
                    v-model="form.textarea_1"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Note"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="12">
              <b-form-group
                label="Service Status"
                label-for="v-ServiceStatus"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ServiceStatus"
                  rules="required"
                >
                  <v-select
                    v-model="form.service_status"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ServiceStatusOptions"
                    :reduce="(ServiceStatusOptions) => ServiceStatusOptions.value"
                    label="title"
                    placeholder="Service Status"
                    class="w-100"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="6">
              <b-form-group
                label="ServiceStartDate"
                label-for="v-ServiceStartDate"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ServiceStartDate"
                  rules="required"
                >
                  <flat-pickr
                    id="v-ServiceStartDate"
                    v-model="form.service_start_date"
                    class="form-control"
                    :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                    placeholder="DD-MM-YYYY"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Note -->
            <b-col cols="6">
              <b-form-group
                label="ServiceEndDate"
                label-for="v-ServiceEndDate"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ServiceEndDate"
                  rules="required"
                >
                  <flat-pickr
                    id="v-ServiceEndDate"
                    v-model="form.service_end_date"
                    class="form-control"
                    :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                    placeholder="DD-MM-YYYY"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Serial Number -->
            <b-col cols="12">
              <b-form-group
                label="Serial Number"
                label-for="v-Serial Number"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Serial Number"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="v-Serial Number"
                      v-model="form.text_3"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Serial Number"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-primary"
                        @click="checkBySerialNumber()"
                      >
                        Check
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small :class="serialclass">{{ serial }}</small>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Latitude -->
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Latitude"
                    label-for="v-Latitude"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Latitude"
                      rules="required"
                    >
                      <b-form-input
                        id="v-Latitude"
                        v-model="form.latitude"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Latitude"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Longtitude -->
                <b-col cols="6">
                  <b-form-group
                    label="Longtitude"
                    label-for="v-Longtitude"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Longtitude"
                      rules="required"
                    >
                      <b-form-input
                        id="v-Longtitude"
                        v-model="form.longitude"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Longtitude"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- submit and reset -->
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="reset"
                    variant="outline-secondary"
                  >
                    Reset
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
        <!--<b-card>
               <b-row>
                <b-col cols="6">
                  <b-form-group label="Province" label-for="v-Province">
                    <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="ProvinceOptions"
                      :reduce="ProvinceOptions => ProvinceOptions.value" id="v-Province" v-model="form.select_6" label="title"
                      :placeholder="province ? province : '--Select Province --'" class="w-100" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Regency" label-for="v-Regency">
                    <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="RegencyOptions"
                      :reduce="RegencyOptions => RegencyOptions.value" id="v-Regency" v-model="form.select_7" label="title"
                      :placeholder="regency ? regency : '--Select Province --'" class="w-100" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="District" label-for="v-District">
                    <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="DistrictOptions"
                      :reduce="DistrictOptions => DistrictOptions.value" id="v-District" v-model="form.select_8" label="title"
                      placeholder="--Select District --" class="w-100" />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Site" label-for="v-Site">
                    <validation-provider #default="{ errors }" name="Site" rules="required">
                      <v-select id="v-Site" v-model="form.select_9" placeholder="Chose  Site" autocomplete="off"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="SiteOptions"
                        :reduce="SiteOptions => SiteOptions.value" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
              </b-row>
            </b-card>-->
      </b-form>
    </validation-observer>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BOverlay, BInputGroupAppend, BInputGroup, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormTextarea, BForm, BButton, BCard, BImg,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    vSelect, BOverlay, BInputGroupAppend, BInputGroup, flatPickr, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox, ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BForm, BButton,
  },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, select_1: 6, service_status: null, service_start_date: null, service_end_date: null, textarea_1: '', text_1: '', text_2: '', text_3: '', text_4: '', text_5: '', text_6: '', checkbox_1: false, imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null, latitude: '', longitude: '',
      },
      ServiceStatusOptions: [
        { title: 'Active', value: 'ACTIVE' },
        { title: 'Expired', value: 'EXPIRED' },
        { title: 'Inactive', value: 'INACTIVE' },
      ],
      serialclass: null,
      serial: null,
      show: false,
      required,
    }
  },
  computed: {
    ...mapState({
      TypeOptions: state => state.type.options,
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
    }),
  },
  created() {
    this.$store.dispatch('type/getAll')
    this.$store.dispatch('region/province')
  },
  mounted() {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  },
  methods: {
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            console.log(this.serial)
            if (true) {
              const formData = this.form
              this.$store.dispatch('device/formPostPut', formData)
                .then(res => {
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                })
                .catch(err => {
                  this.show = false
                  console.error('POST/PUT ERROR:', err) // Log the dispatch error
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                })
            } else {
              this.show = false
              this.notification('Failed', 'CloseIcon', 'danger', 'Serial NOT FOUND')
            }
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
        .catch(err => {
          console.error('VALIDATION ERROR:', err) // Log the validation error
          this.show = false
          this.notification('Failed', 'CloseIcon', 'danger', 'Validation error occurred')
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    checkBySerialNumber() {
      this.$store.dispatch('device/checkBySerialNumber', this.form.text_3).then(data => {
        console.log(data)
        if (data.message === 'SUCCESS') {
          this.serialclass = 'text-success'
        } else {
          this.serialclass = 'SUCCESS'
        }
        this.serial = data.message
      })
    },
    getData(id) {
      this.$store.dispatch('device/getById', id).then(data => {
        this.form = data
        this.form.id = data.id
        this.form.select_1 = data.device_type_id
        this.form.text_2 = data.code
        this.form.text_2 = data.name
        this.form.textarea_1 = data.note
        this.form.text_3 = data.serial_number
        this.form.service_status = data.service_status
        this.form.service_start_date = data.service_start_date
        this.form.service_end_date = data.service_end_date
        this.form.latitude = data.latitude
        this.form.longitude = data.longitude
        this.serial = 'SUCCESS'
        this.show = false
        console.log(this.form)
      })
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
